import React, { useEffect } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import FormControl from '../../../../Components/Form/FormControl';
import { DEFAULT_SLOT_DURATION_OPTIONS } from '../../../Manager/Components/ManagerWrapper/Calendar/ManagerCalendarViewSettings/ManagerCalendarViewSettings';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import { CalendarViewIntervalEnum } from '../../Enums/CalendarViewInterval.enum';

interface Props {
	onSlotDurationChange: (slotDuration: CalendarViewIntervalEnum) => void;
	value?: SelectValue;
}

const WorkplaceCalendarSlotDurationSwitch: React.FC<Props> = ({
	value,
	onSlotDurationChange,
}) => {
	const formMethods = useForm({});

	useEffect(() => {
		formMethods.reset({ slotDuration: value });
	}, [value]);

	const handleChangeSlotDuration = (value: SelectValue) => {
		onSlotDurationChange(value.value as CalendarViewIntervalEnum);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<FormControl
				name='slotDuration'
				label='component.calendarViewSettings.slotDuration.title'
				inLine
				hideRequired
				labelStyle={{ minWidth: '115px', textAlign: 'right' }}
				onChange={handleChangeSlotDuration}>
				<Select options={DEFAULT_SLOT_DURATION_OPTIONS} portal />
			</FormControl>
		</FormWrapper>
	);
};

export default WorkplaceCalendarSlotDurationSwitch;
